const routeComponent = "app/ReportsV2/WidgetMultipleChoiceQuestions"

export const GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER = `${routeComponent}/GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER`
export const GET_LIST_MULTIPLE_CHOICE_QUESTIONS_SUCCESS = `${routeComponent}/GET_LIST_MULTIPLE_CHOICE_QUESTIONS_SUCCESS`
export const GET_LIST_MULTIPLE_CHOICE_QUESTIONS_FAILED = `${routeComponent}/GET_LIST_MULTIPLE_CHOICE_QUESTIONS_FAILED`
